import React from 'react';
import Panel from 'components/v2/Panel';
import PanelSection from 'components/v2/PanelSection';
import classnames from 'classnames';
export default function Card({ children, className, header, footer, panelClassName, }) {
    return (React.createElement(Panel, { className: className },
        header && header(),
        React.createElement(PanelSection, { className: classnames(panelClassName, 'flex-1') }, children),
        footer && footer()));
}
